(function () {
  'use strict';

  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-product-swiper]').forEach((el) => {
      if (el._swiperInit) return;

      el._swiperInit = true;

      new Swiper(el, {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: el.querySelector('[data-swiper-pagination]'),
          clickable: true
        }
      });
    });
  }

  function initSwatches() {
    document.querySelectorAll('[data-swatch-group]').forEach((group) => {
      if (group._swatchInit) return;
      group._swatchInit = true;

      const firstActive = group.querySelector('.product-card__swatch--active');

      if (firstActive) {
        firstActive.style.setProperty(
          '--swatch-active-color',
          firstActive.style.backgroundColor
        );
      }

      group.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-swatch-value]');
        if (!btn) return;

        group.querySelectorAll('[data-swatch-value]').forEach((swatchBtn) => {
          swatchBtn.classList.remove('product-card__swatch--active');
          swatchBtn.setAttribute('aria-pressed', 'false');
          swatchBtn.style.removeProperty('--swatch-active-color');
        });

        btn.classList.add('product-card__swatch--active');
        btn.setAttribute('aria-pressed', 'true');
        btn.style.setProperty('--swatch-active-color', btn.style.backgroundColor);

        const card = btn.closest('[data-product-card]');
        if (!card) return;

        const newSrc = btn.dataset.swatchImage;
        const newVariantId = btn.dataset.variantId;
        const newCompareAtPrice = btn.dataset.compareAtPrice || '0';

        const atcBtn = card.querySelector('[data-atc-btn]');
        const buyNowBtn = card.querySelector('[data-buy-now-btn]');

        if (atcBtn && newVariantId) {
          atcBtn.dataset.variantId = newVariantId;
          atcBtn.dataset.compareAtPrice = newCompareAtPrice;
        }

        if (buyNowBtn && newVariantId) {
          buyNowBtn.dataset.variantId = newVariantId;
        }

        const regularPriceEl = card.querySelector('[data-product-price-regular]');
        const salePriceEl = card.querySelector('[data-product-price-sale]');
        const comparePriceEl = card.querySelector('[data-product-price-compare]');

        const newPriceText = btn.dataset.price || '';
        const comparePriceText = btn.dataset.compareAtPrice || '';
        const newPriceNum = parseInt(btn.dataset.priceRaw || '0', 10);
        const compareAtPriceNum = parseInt(btn.dataset.compareAtPriceRaw || '0', 10);

        if (regularPriceEl || salePriceEl || comparePriceEl) {
          if (compareAtPriceNum > newPriceNum) {
            if (salePriceEl) {
              salePriceEl.textContent = newPriceText;
              salePriceEl.hidden = false;
            }
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePriceText;
              comparePriceEl.hidden = false;
            }
            if (regularPriceEl) regularPriceEl.hidden = true;
          } else {
            if (regularPriceEl) {
              regularPriceEl.textContent = newPriceText;
              regularPriceEl.hidden = false;
            }
            if (salePriceEl) salePriceEl.hidden = true;
            if (comparePriceEl) comparePriceEl.hidden = true;
          }
        }

        const swiperEl = card.querySelector('[data-product-swiper]');

        if (newSrc) {
          if (swiperEl && swiperEl.swiper) {
            const activeSlide = swiperEl.swiper.slides[swiperEl.swiper.activeIndex];
            const activeImg = activeSlide?.querySelector('img');
            if (activeImg) {
              activeImg.src = newSrc;
              activeImg.removeAttribute('srcset');
            }
          } else {
            const primaryImg = card.querySelector(
              '.product-card__img--primary, .product-card__img'
            );
            if (primaryImg) {
              primaryImg.src = newSrc;
              primaryImg.removeAttribute('srcset');
            }
          }
        }
      });
    });
  }

  function getCardQuantity(btn) {
    const card = btn.closest('[data-product-card]');
    const input = card?.querySelector('[data-quantity-input]');

    let quantity = parseInt(input?.value || '1', 10);

    if (!Number.isFinite(quantity) || quantity < 1) {
      quantity = 1;
    }

    quantity = Math.floor(quantity);

    if (input) input.value = quantity;

    return quantity;
  }

  function initQuantityControls() {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card._quantityInit) return;

      const input = card.querySelector('[data-quantity-input]');
      const minus = card.querySelector('[data-quantity-minus]');
      const plus = card.querySelector('[data-quantity-plus]');

      if (!input || !minus || !plus) return;

      card._quantityInit = true;

      const normalize = () => {
        let value = parseInt(input.value || '1', 10);

        if (!Number.isFinite(value) || value < 1) value = 1;

        input.value = Math.floor(value);
        return Number(input.value);
      };

      minus.addEventListener('click', () => {
        input.value = Math.max(1, normalize() - 1);
      });

      plus.addEventListener('click', () => {
        input.value = normalize() + 1;
      });

      input.addEventListener('change', normalize);

      input.addEventListener('input', () => {
        input.value = input.value.replace(/[^0-9]/g, '');
      });
    });
  }

  async function fetchCartState() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function applyCompareAtToCart(cart, variantId, compareAtPrice) {
    const compareAt = Number(compareAtPrice || 0);

    if (!cart || !Array.isArray(cart.items) || !variantId || !compareAt) {
      return cart;
    }

    cart.items.forEach((item) => {
      const itemVariantId = item.variant_id || item.id;
      const finalPrice = Number(item.final_price || item.price || 0);

      if (
        String(itemVariantId) !== String(variantId) ||
        compareAt <= finalPrice
      ) {
        return;
      }

      item._compareAtPrice = compareAt;
      item._compareAtLinePrice =
        compareAt * Math.max(1, Number(item.quantity || 1));
    });

    return cart;
  }

  async function syncCartUI(cart) {
    if (!cart) return null;

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('cart-count--hidden', cart.item_count === 0);
    });

    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      el.textContent = '(' + cart.item_count + ')';
    });

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      await cartDrawer.refresh(cart);
    }

    return cartDrawer || null;
  }

  async function addVariantToCart(variantId, quantity) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity)
          }
        ]
      })
    });

    if (!res.ok) {
      let message = 'Add to cart failed';
      try {
        const data = await res.json();
        message = data?.description || data?.message || message;
      } catch (_) {}
      throw new Error(message);
    }

    return res.json();
  }

  function initATCButtons() {
    document.querySelectorAll('[data-atc-btn]').forEach((btn) => {
      if (btn._atcInit) return;
      btn._atcInit = true;

      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const variantId = btn.dataset.variantId;
        const compareAtPrice = btn.dataset.compareAtPrice;

        if (!variantId || btn.disabled) return;

        const quantity = getCardQuantity(btn);

        btn.classList.add('product-card__atc-btn--loading');
        btn.disabled = true;

        try {
          await addVariantToCart(variantId, quantity);

          const cart = await fetchCartState();

          applyCompareAtToCart(
            cart,
            variantId,
            compareAtPrice
          );

          const cartDrawer = await syncCartUI(cart);

          btn.classList.remove('product-card__atc-btn--loading');
          btn.classList.add('product-card__atc-btn--success');

          if (
            btn.dataset.cartType === 'drawer' &&
            cartDrawer &&
            typeof cartDrawer.open === 'function'
          ) {
            cartDrawer.open();
          }

          if (btn.dataset.cartType === 'page') {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }

          setTimeout(() => {
            btn.classList.remove('product-card__atc-btn--success');
            btn.disabled = false;
          }, 700);
        } catch (err) {
          console.error('[ProductCard ATC]', err);

          btn.classList.remove('product-card__atc-btn--loading');
          btn.disabled = false;

          window.dispatchEvent(
            new CustomEvent('product-card:error', {
              detail: { message: err.message }
            })
          );
        }
      });
    });
  }

  function initBuyNowButtons() {
    document.querySelectorAll('[data-buy-now-btn]').forEach((btn) => {
      if (btn._buyNowInit) return;
      btn._buyNowInit = true;

      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const variantId = btn.dataset.variantId;

        if (!variantId || btn.disabled) return;

        const quantity = getCardQuantity(btn);

        btn.classList.add('product-card__buying');
        btn.disabled = true;

        try {
          await addVariantToCart(variantId, quantity);

          /*
             Direct checkout after the product has been added.
             Shopify checkout remains the store's normal checkout flow.
          */
          window.location.href = window.Shopify.routes.root + 'checkout';
        } catch (err) {
          console.error('[ProductCard Buy Now]', err);

          btn.classList.remove('product-card__buying');
          btn.disabled = false;

          window.dispatchEvent(
            new CustomEvent('product-card:error', {
              detail: { message: err.message }
            })
          );
        }
      });
    });
  }

  window.ProductCard = {
    fetchCartState,
    applyCompareAtToCart,
    syncCartUI,
    init
  };

  function init() {
    initSwipers();
    initSwatches();
    initQuantityControls();
    initATCButtons();
    initBuyNowButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
